import { graphql } from '@/gql/graphql';

export const GetEditablePersonProfile = graphql(`
  query GetEditablePersonProfile($personId: String!) {
    person(
      where: {
        id: { _eq: $personId }
        is_managed: { _eq: true }
        _or: [
          {
            person_teams: {
              team: {
                _or: [
                  { permissions: { _has_key: "edit_others" } }
                  { root_event: { permissions: { _has_key: "edit_others" } } }
                ]
              }
            }
          }
          {
            person_events: {
              event: { permissions: { _has_key: "edit_others" } }
            }
          }
        ]
      }
      limit: 1
    ) {
      id
      name
      first_name
      last_name
      avatar_id
      color
    }
  }
`);
